// shared/src/schemas/amm-liquidity-snapshot.ts
// Zod schema for `amm_liquidity_snapshots` table (D1 migration 0122).
// Sibling of amm_snapshots — the Dune-liquidity group split into its own store so
// a Dune 402 can't fail-close the Revert-positions write. Same 3-column shape;
// A2 drift-detector enforces field-name parity.

import { z } from 'zod';

export const AmmLiquiditySnapshotSchema = z.object({
  id:         z.string(),
  created_at: z.string().datetime(),
  payload:    z.string(),    // JSON: { raw:{dune_pools}, computed:{benchmark,pools,target_pools,categories}, source_status:{dune} }
});

export type AmmLiquiditySnapshot = z.infer<typeof AmmLiquiditySnapshotSchema>;
